import { ProductIndexItemInterface } from "../../interfaces/apiV2/shared/ProductIndexItemInterface";
import {
    mapOldModelToOlderModelAssociation,
    ProductAddOnCardInterface,
    ProductAssociationCardInterface,
    ProductAssociatedInterface,
    ProductOlderModelAssociationInterface,
} from "../../interfaces/apiV2/product/ProductAssociatedInterface";

const mergeSimilarProducts = (
    groups?: ProductAssociatedInterface,
): ProductAssociationCardInterface[] => {
    const products = [
        ...(groups?.up_sell ?? []),
        ...(groups?.previous_model ?? []),
    ];
    const seen = new Set<number>();

    return products.filter((product) => {
        if (seen.has(product.id)) {
            return false;
        }
        seen.add(product.id);
        return true;
    });
};

export const partitionAssociationGroups = (
    accessories: ProductIndexItemInterface[],
    groups?: ProductAssociatedInterface,
): {
    accessories: ProductIndexItemInterface[];
    similarProducts: ProductAssociationCardInterface[];
    addOns: ProductAddOnCardInterface[];
    olderModels: ProductOlderModelAssociationInterface[];
} => ({
    accessories,
    similarProducts: mergeSimilarProducts(groups),
    addOns: groups?.add_on ?? [],
    olderModels: (groups?.old_model ?? []).map(
        mapOldModelToOlderModelAssociation,
    ),
});
